import type { HTMLAttributes, ReactNode, Ref } from 'react';
import { forwardRef } from 'react';

import { TypographyStyled } from './Typography.styled';

type TypographyPropsT = HTMLAttributes<HTMLElement> & {
  children: ReactNode;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  color?:
    | 'black'
    | 'light'
    | 'darkBlue'
    | 'primaryText'
    | 'lightGrey'
    | 'grey'
    | 'darkGrey'
    | 'dark'
    | 'purple'
    | 'yellow'
    | 'success'
    | 'warning'
    | 'error'
    | 'semiTransparent'
    | 'darkGreen'
    | 'darkPurple';
  align?: 'left' | 'right' | 'center';
  family?: 'primary' | 'secondary';
  variant?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'body1'
    | 'body2'
    | 'body3'
    | 'body4'
    | 'body5'
    | 'body6';
  weight?: 'normal' | 'medium' | 'semibold' | 'bold';
  isInline?: boolean;
};

const Typography = forwardRef<HTMLElement, TypographyPropsT>(
  ({ children, variant, ...restProps }, ref) => {
    const tagName = variant?.includes('h') ? variant : 'p';

    return (
      // Polymorphic `as` changes the DOM node type; refs still attach correctly for Tooltip parents.
      <TypographyStyled
        ref={ref as Ref<HTMLParagraphElement>}
        variant={variant}
        as={tagName}
        {...restProps}
      >
        {children}
      </TypographyStyled>
    );
  }
);

Typography.displayName = 'Typography';

export default Typography;
